import { NavGroup } from "../types/nav-group.type";

export const WORLD_NAV_GROUPS: NavGroup[] = [
	{
		id: 'world',
		label: 'World',
		category: 'world',
		countKeys: ['world'],
		links: [{ slug: '', label: 'Overview', icon: 'home', countKey: 'world' }],
	},
	{
		id: 'places',
		label: 'Places',
		category: 'places',
		countKeys: ['regions', 'pointsOfInterest'],
		links: [
			{ slug: 'regions', label: 'Regions', icon: 'globe', countKey: 'regions' },
			{ slug: 'points-of-interest', label: 'Points of Interest', icon: 'map', countKey: 'pointsOfInterest' },
		],
	},
	{
		id: 'people',
		label: 'People & Orgs',
		category: 'people',
		countKeys: ['nonPlayerCharacters', 'playerCharacters', 'factions', 'merchants'],
		links: [
			{ slug: 'non-player-characters', label: 'Non-player Characters', icon: 'person', countKey: 'nonPlayerCharacters' },
			{ slug: 'player-characters', label: 'Player Characters', icon: 'group', countKey: 'playerCharacters' },
			{ slug: 'factions', label: 'Factions', icon: 'shield', countKey: 'factions' },
			{ slug: 'merchants', label: 'Merchants', icon: 'shop', countKey: 'merchants' },
		],
	},
	{
		id: 'items',
		label: 'Items & Trade',
		category: 'items',
		countKeys: ['items', 'goodsServices', 'tomes'],
		links: [
			{ slug: 'items', label: 'Items', icon: 'box', countKey: 'items' },
			{ slug: 'goods-services', label: 'Goods & Services', icon: 'bag', countKey: 'goodsServices' },
			{ slug: 'tomes', label: 'Tomes', icon: 'book', countKey: 'tomes' },
		],
	},
	{
		id: 'story',
		label: 'Story',
		category: 'story',
		countKeys: ['quests', 'encounters'],
		links: [
			{ slug: 'quests', label: 'Quests', icon: 'flag', countKey: 'quests' },
			{ slug: 'encounters', label: 'Encounters', icon: 'target', countKey: 'encounters' },
		],
	},
	{
		id: 'cosmology',
		label: 'Cosmology',
		category: 'cosmology',
		countKeys: ['pantheons', 'gods', 'domains'],
		links: [
			{ slug: 'pantheons', label: 'Pantheons', icon: 'atom', countKey: 'pantheons' },
			{ slug: 'gods', label: 'Gods', icon: 'spark', countKey: 'gods' },
			{ slug: 'domains', label: 'Domains', icon: 'media', countKey: 'domains' },
		],
	},
	{
		id: 'media',
		label: 'Media',
		category: 'media',
		links: [{ slug: 'media', label: 'Media Library', icon: 'media' }],
	},
];